import { useEffect } from 'react';

const SEO = ({ 
  title = 'Garud Stacks - Enterprise Technology Solutions',
  description = 'Garud Stacks delivers cutting-edge enterprise technology solutions including AI, cloud computing, and digital transformation services.',
  image = 'https://garudstacks.tech/img/logo.png',
  url = 'https://garudstacks.tech',
  type = 'website',
  keywords = 'enterprise technology, AI solutions, cloud computing, digital transformation, software development'
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Update meta description
    let descMeta = document.querySelector('meta[name="description"]');
    if (descMeta) {
      descMeta.setAttribute('content', description);
    }

    // Update meta keywords
    let keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (!keywordsMeta) {
      keywordsMeta = document.createElement('meta');
      keywordsMeta.name = 'keywords';
      document.head.appendChild(keywordsMeta);
    }
    keywordsMeta.setAttribute('content', keywords);

    // Open Graph Tags
    const ogTags = {
      'property:og:title': title,
      'property:og:description': description,
      'property:og:image': image,
      'property:og:url': url,
      'property:og:type': type,
      'property:og:site_name': 'Garud Stacks'
    };

    Object.entries(ogTags).forEach(([key, value]) => {
      const [attr, name] = key.split(':');
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', value);
    });

    // Twitter Card Tags
    const twitterTags = {
      'name:twitter:card': 'summary_large_image',
      'name:twitter:title': title,
      'name:twitter:description': description,
      'name:twitter:image': image,
      'name:twitter:site': '@GarudStacks'
    };

    Object.entries(twitterTags).forEach(([key, value]) => {
      const [attr, name] = key.split(':');
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', value);
    });

    // Canonical Tag
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    // Additional SEO Tags
    const additionalMetas = {
      'robots': 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
      'googlebot': 'index, follow',
      'revisit-after': '7 days',
      'language': 'English',
      'author': 'Garud Stacks'
    };

    Object.entries(additionalMetas).forEach(([name, content]) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

  }, [title, description, image, url, type, keywords]);

  // Add structured data (Schema.org JSON-LD)
  useEffect(() => {
    const schemaScript = document.querySelector('script[type="application/ld+json"]');
    if (!schemaScript) {
      const schema = document.createElement('script');
      schema.type = 'application/ld+json';
      schema.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': 'Garud Stacks',
        'url': 'https://garudstacks.tech',
        'description': 'Enterprise technology solutions and digital transformation services',
        'logo': 'https://garudstacks.tech/img/logo.png',
        'sameAs': [
          'https://www.linkedin.com/company/garud-stacks',
          'https://twitter.com/garudstacks',
          'https://www.facebook.com/garudstacks'
        ],
        'contactPoint': {
          '@type': 'ContactPoint',
          'telephone': '+91-XXX-XXX-XXXX',
          'contactType': 'Customer Service',
          'email': 'contact@garudstacks.tech'
        },
        'address': {
          '@type': 'PostalAddress',
          'addressCountry': 'IN',
          'addressLocality': 'India'
        }
      });
      document.head.appendChild(schema);
    }
  }, []);

  return null;
};

export default SEO;
